import { useState } from "react";
import { Link } from "react-router-dom";
import backgroundVideo from './videos/backgroundVideo.mp4';
import villaTorlonia from './videos/villaTorlonia.mp4'
import Slider from 'react-slick';
import emailjs from 'emailjs-com';
import 'bootstrap-icons/font/bootstrap-icons.css';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import photo1 from './images/photo1.avif';
import photo2 from './images/photo2.avif';
import photo3 from './images/photo3.avif';
import photo4 from './images/photo4.avif';
import photo5 from './images/photo5.avif';
import photo6 from './images/photo6.avif';
import photo7 from './images/photo7.avif';
import photo8 from './images/photo8.avif';
import photo9 from './images/photo9.avif';
import photo10 from './images/photo10.avif';
import photo11 from './images/photo11.avif';
import photo12 from './images/photo12.avif';
import photo13 from './images/photo13.avif';
import photo14 from './images/photo14.avif';
import photo15 from './images/photo15.avif';
import photo16 from './images/photo16.avif';
import photo17 from './images/photo17.avif';
import photo18 from './images/photo18.avif';
import photo19 from './images/photo19.avif';
import photo20 from './images/photo20.avif';
import photo21 from './images/photo21.avif';
import photo22 from './images/photo22.avif';
import photo23 from './images/photo23.avif';
import photo24 from './images/photo24.avif';
import photo25 from './images/photo25.avif';
import photo26 from './images/photo26.avif';
import photo27 from './images/photo27.avif';
import photo28 from './images/photo28.avif';
import photo29 from './images/photo29.avif';

export default function App() {
  const [showContact, setShowContact] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      owner_name: 'Amir',
      user_name: name,
      user_email: email,
      user_phone: phone,
      message: message,
    };

    emailjs.send('service_hwjajxk', 'template_x5x2utb', templateParams, 'wL0TWpYxdl84ufXb-')
      .then(
        (response) => {
          console.log('Email sent successfully!', response.status, response.text);
          setSubmitted(true);
          setName('');
          setPhone('');
          setEmail('');
          setMessage('');
          setTimeout(() => setSubmitted(false), 5000);
        },
        (err) => {
          console.error('Failed to send email. Error:', err);
        }
      );
  }

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <div className="container">
      <video src={backgroundVideo} autoPlay loop muted playsInline className="background-video" />
      <div className="video-overlay"></div>

      <nav className="main-nav">
        <div className="nav-content">
          <div className="logo-wrapper">
            <span className="logo-text">Genach Conservation</span>
            <span className="logo-subtitle">Excellence in Heritage</span>
          </div>
          
          <div className="nav-links">
            <a href="#projects" className="nav-link">Projects</a>
            <a href="#services" className="nav-link">Services</a>
            <a href="#about" className="nav-link">About</a>
            <a href="#contact" className="nav-link nav-link-cta">Contact</a>
          </div>

          <button className={`hamburger ${isOpen ? "active" : ""}`} onClick={toggleMenu} aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${isOpen ? "active" : ""}`}>
        <button className="close-menu" onClick={closeMenu} aria-label="Close menu">×</button>
        <a href="#projects" onClick={closeMenu}>Projects</a>
        <a href="#services" onClick={closeMenu}>Services</a>
        <a href="#about" onClick={closeMenu}>About</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>
      </div>

      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="title-main">Conserving History</span>
            <span className="title-sub">Creating Legacy</span>
          </h1>
          <p className="hero-description">
            Conservation of antiquities and creation of artistic mosaic works for companies and private clients
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary" onClick={() => setShowContact(true)}>
              <span>Schedule a Meeting</span>
              <i className="bi bi-arrow-right"></i>
            </a>
            <a href="https://wa.me/9720523948920" target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp">
              <i className="bi bi-whatsapp"></i>
              <span>WhatsApp Booking</span>
            </a>
          </div>
        </div>
        <div className="scroll-indicator">
          <span>Scroll to explore</span>
          <i className="bi bi-chevron-down"></i>
        </div>
      </section>

      <section className="villa-section">
        <div className="section-container">
          <div className="villa-content">
            <div className="villa-text">
              <span className="section-tag">Featured Project</span>
              <h2 className="section-title">Villa Torlonia Catacombs</h2>
              <p className="section-location">Rome, Italy</p>
              <p className="villa-description">
                Amir Genach elevated his company to unprecedented heights by undertaking the conservation of the Jewish catacombs at Villa Torlonia. This monumental project encompasses 1.2 kilometers of ancient passages with nearly 4,000 tombs requiring meticulous preservation. The work was completed with exceptional success, setting new standards in archaeological conservation.
              </p>
              <a 
                href="https://www.timesofisrael.com/in-rome-spectacular-ancient-jewish-catacombs-opening-haunted-by-delays/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="villa-link"
              >
                Read The Times of Israel Article
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
            <div className="villa-video-wrapper">
              <video src={villaTorlonia} autoPlay loop muted playsInline className="villa-video" />
              <div className="video-overlay-gradient"></div>
            </div>
          </div>
        </div>
      </section>

      <section id="projects" className="projects-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">Our Work</span>
            <h2 className="section-title">Selected Conservation Projects</h2>
            <p className="section-subtitle">Excellence in restoration and conservation of cultural heritage</p>
          </div>

          <Slider
            dots={true}
            infinite={true}
            speed={600}
            slidesToShow={1}
            slidesToScroll={1}
            arrows={true}
            autoplay={true}
            autoplaySpeed={4000}
            pauseOnHover={true}
            className="projects-slider"
          >
            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo1} alt="Omrit fresco before conservation" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo2} alt="Omrit fresco after conservation" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Fresco Conservation at Omrit Ancient Site</h3>
                  <p>Delicate restoration conserving ancient wall paintings using traditional techniques</p>
                </div>
              </div>
            </div>

            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo3} alt="Lime kiln before restoration" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo4} alt="Lime kiln after restoration" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Historic Lime Kiln Conservation</h3>
                  <p>Complex conservation work in Rosh HaAyin following strict conservation standards</p>
                </div>
              </div>
            </div>

            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo5} alt="Lime kiln detail before" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo6} alt="Lime kiln detail after" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Structural Detail Restoration</h3>
                  <p>Precision work maintaining historical authenticity and structural integrity</p>
                </div>
              </div>
            </div>

            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo20} alt="Historic structure before" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo21} alt="Historic structure after" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Heritage Site Preservation</h3>
                  <p>Comprehensive restoration ensuring longevity for future generations</p>
                </div>
              </div>
            </div>

            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo24} alt="Bahá'í column before" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo25} alt="Bahá'í column after" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Bahá'í Gardens Column Conservation</h3>
                  <p>Meticulous conservation of architectural elements in sacred gardens</p>
                </div>
              </div>
            </div>

            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo7} alt="Capital before restoration" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo8} alt="Capital after restoration" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Architectural Capital Restoration</h3>
                  <p>Expert conservation of decorative architectural elements</p>
                </div>
              </div>
            </div>

            <div className="project-slide">
              <div className="project-card">
                <div className="project-images">
                  <div className="image-wrapper">
                    <span className="image-label">Before</span>
                    <img src={photo22} alt="Caesarea Theater before" />
                  </div>
                  <div className="image-wrapper">
                    <span className="image-label">After</span>
                    <img src={photo23} alt="Caesarea Theater after" />
                  </div>
                </div>
                <div className="project-info">
                  <h3>Caesarea Theater Proscenium</h3>
                  <p>Restoration and conservation of this iconic archaeological landmark</p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section>

      <section className="mosaics-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">Artistry</span>
            <h2 className="section-title">Mosaic Masterworks</h2>
            <p className="section-subtitle">Contemporary creations inspired by ancient techniques</p>
          </div>

          <Slider
            dots={true}
            infinite={true}
            speed={600}
            slidesToShow={1}
            slidesToScroll={1}
            arrows={true}
            autoplay={true}
            autoplaySpeed={4500}
            pauseOnHover={true}
            className="mosaics-slider"
          >
            <div className="mosaic-slide">
              <div className="mosaic-card">
                <div className="mosaic-image">
                  <img src={photo17} alt="Seven Species mosaic" />
                  <div className="mosaic-overlay"></div>
                </div>
                <div className="mosaic-info">
                  <h3>Papal Gift from Chief Rabbi</h3>
                  <p>A magnificent mosaic featuring the Seven Species, symbolizing blessing and heritage, presented as a gift to the Pope by the Chief Rabbi of Israel</p>
                </div>
              </div>
            </div>

            <div className="mosaic-slide">
              <div className="mosaic-card">
                <div className="mosaic-image">
                  <img src={photo18} alt="David mosaic replica" />
                  <div className="mosaic-overlay"></div>
                </div>
                <div className="mosaic-info">
                  <h3>Ancient Synagogue Replica</h3>
                  <p>Faithful reproduction of the ancient David mosaic from a Gaza synagogue, now displayed at Nitzan's visitor center</p>
                </div>
              </div>
            </div>

            <div className="mosaic-slide">
              <div className="mosaic-card">
                <div className="mosaic-image">
                  <img src={photo19} alt="Mosaic of Peace" />
                  <div className="mosaic-overlay"></div>
                </div>
                <div className="mosaic-info">
                  <h3>The Mosaic of Peace</h3>
                  <p>Unveiled by Prince Edward alongside ministers and Knesset members at Haifa Municipality, promoting harmony and unity</p>
                </div>
              </div>
            </div>

            <div className="mosaic-slide">
              <div className="mosaic-card">
                <div className="mosaic-image">
                  <img src={photo26} alt="Sde Dov mosaic" />
                  <div className="mosaic-overlay"></div>
                </div>
                <div className="mosaic-info">
                  <h3>Tel Aviv Cultural Heritage</h3>
                  <p>Reproduction from Sde Dov to the Tel Aviv Hall of Culture, presented in the presence of Zubin Mehta</p>
                </div>
              </div>
            </div>

            <div className="mosaic-slide">
              <div className="mosaic-card">
                <div className="mosaic-image">
                  <img src={photo28} alt="Van Gogh Sunflower" />
                  <div className="mosaic-overlay"></div>
                </div>
                <div className="mosaic-info">
                  <h3>Van Gogh's Sunflowers</h3>
                  <p>Artistic interpretation of the iconic painting recreated in stunning mosaic form</p>
                </div>
              </div>
            </div>

            <div className="mosaic-slide">
              <div className="mosaic-card">
                <div className="mosaic-image">
                  <img src={photo29} alt="Custom mosaic" />
                  <div className="mosaic-overlay"></div>
                </div>
                <div className="mosaic-info">
                  <h3>Bespoke Design</h3>
                  <p>Custom mosaic tailored to complement architectural elements and color schemes</p>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </section>

      <section id="services" className="services-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">Expertise</span>
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle">Comprehensive conservation and restoration solutions</p>
          </div>

          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <i className="bi bi-palette"></i>
              </div>
              <h3>Fresco Conservation</h3>
              <p>Delicate restoration and conservation of ancient wall paintings using traditional techniques and modern scientific methods</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="bi bi-grid-3x3"></i>
              </div>
              <h3>Ancient Mosaic Creation</h3>
              <p>Authentic mosaic design and execution using materials and methods faithful to antiquity</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="bi bi-people"></i>
              </div>
              <h3>Heritage Workshops</h3>
              <p>Interactive educational sessions teaching traditional techniques including mosaic and pottery crafts</p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="bi bi-building"></i>
              </div>
              <h3>Structural Conservation</h3>
              <p>Comprehensive conservation of historic buildings with significant cultural and architectural value</p>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="about-section">
        <div className="section-container">
          <div className="about-content">
            <div className="about-text">
              <span className="section-tag">Our Story</span>
              <h2 className="section-title">Three Decades of Excellence</h2>
              <p>
                With over 30 years of expertise in conserving historical sites, ancient architecture, and heritage landmarks of both national and international importance, we have successfully delivered numerous prestigious projects in Israel and abroad — including the renowned conservation of the Jewish catacombs at Villa Torlonia in Rome.
              </p>
              <p>
                Our dedicated team of experts blends cutting-edge technology with an unwavering commitment to authenticity and the conservation of cultural values.
              </p>
              <p>
                We partner with municipalities, public institutions, developers, and academic organizations to ensure that the legacy of historic sites endures for generations to come.
              </p>
            </div>
            <div className="about-stats">
              <div className="stat-item">
                <span className="stat-number">30+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">200+</span>
                <span className="stat-label">Projects Completed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">90%+</span>
                <span className="stat-label">Returning Clients</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="contact-section">
        <div className="section-container">
          <div className="section-header">
            <span className="section-tag">Get in Touch</span>
            <h2 className="section-title">Start Your Project</h2>
            <p className="section-subtitle">Let's discuss how we can conserve your heritage</p>
          </div>

          <div className="contact-wrapper">
            <div className="contact-info">
              <div className="contact-item">
                <i className="bi bi-person-circle"></i>
                <div>
                  <h4>Project Manager</h4>
                  <p><strong>Amir Genach</strong></p>
                  <p>Available 24/6 via all contact methods</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-telephone"></i>
                <div>
                  <h4>Phone</h4>
                  <a href="tel:+972523948920">+972-52-3948920</a>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-envelope"></i>
                <div>
                  <h4>Email</h4>
                  <a href="mailto:genach2@bezeqint.net">genach2@bezeqint.net</a>
                </div>
              </div>
            </div>

            <form className="contact-form" onSubmit={handleSubmit}>
              {submitted && (
                <div className="success-message">
                  <i className="bi bi-check-circle"></i>
                  <span>Message sent successfully! We'll be in touch soon.</span>
                </div>
              )}
              
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Full Name"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  placeholder="Phone Number"
                  required
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  placeholder="Email Address"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="form-group">
                <textarea
                  placeholder="Tell us about your project..."
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows="5"
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary btn-full">
                <span>Send Message</span>
                <i className="bi bi-send"></i>
              </button>
            </form>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Genach Conservation</h3>
            <p>Conserving heritage, creating legacy</p>
          </div>
          <div className="footer-links">
            <Link to="/AccessibilityStatement">Accessibility Statement</Link>
          </div>
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} All rights reserved to Genach Conservation</p>
          </div>
        </div>
      </footer>
    </div>
  );
}